import { payloadHelper, autoTopPaddingHelper } from '../helper'
import { Loader } from '../component'
import { Events } from './events'

export const Setup = () => {
	const initComponents = () => {
		Loader.init()
	}

	const handleAjaxComplete = (payload: any) => {
		initComponents()

		if (payloadHelper.HideLoader(payload)) {
			Loader.hideMain()
		}

		if (payloadHelper.ExistUrl(payload)) {
			window.history.pushState('', '', payload.url)
		}
	}

	const handleBeforeAjaxConfirm = (_: any, settings: any) => {
		if (!settings.nette) {
			return null
		}
		const question = settings.nette.el.data('confirm')
		if (question) {
			// eslint-disable-next-line no-restricted-globals,no-undef,no-alert
			return confirm(question)
		}
		return null
	}

	const handleDOMLoad = () => {
		initComponents()
	}

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	const handleLoad = () => {}

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	const handleNetteExtLoad = () => {}

	const handleResizeWindow = () => {
		autoTopPaddingHelper.calculateTopPaddingFilter()
	}

	const apply = () => {
		const events = Events()
		events.onAjaxComplete(handleAjaxComplete)
		events.onBeforeAjaxConfirm(handleBeforeAjaxConfirm)
		events.onDOMLoad(handleDOMLoad)
		events.onLoad(handleLoad)
		events.onNetteExtLoad(handleNetteExtLoad)
		events.onResizeWindow(handleResizeWindow)
	}

	return {
		apply,
	}
}
